import PropTypes from 'prop-types';

import { lcSideFilterType } from 'humanity/components/lcSideFilter';
import { lcTopFilterType } from 'humanity/components/lcTopFilter';
import { lcMastheadType } from 'humanity/sections/lcMasthead';

export const learningCenterPageType = PropTypes.shape({
  sectionsCollection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([lcMastheadType, lcTopFilterType, lcSideFilterType])
    ),
  }),
});

export const learningCenterPageProps = {
  pageContent: learningCenterPageType.isRequired,
  parentSlug: PropTypes.string.isRequired,
  preview: PropTypes.bool,
};
